import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  dropdownFetch,
  getCityByState,
  getCurrentDateTime,
  getKeyPathValue,
  getStatesByCountry,
  request,
  toast
} from '../../../../../utils';
import { useCallback, useEffect, useState } from 'react';
import { GENDER_DROPDOWN, SCHEME_NAME } from '../../../../../constants/dropdown';
import { CustomButtonn } from '../../../../../components';
import { useLocation } from 'react-router-dom';
import { dateFormatter, formatDate } from '../../../../../utils';
import { BASE_URL_FOR_FILE } from '../../../../../utils/BaseUrl';

const TABLE_COLUMNS = [
  {
    header: 'Card No.',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.card_no}`}
        </span>
      );
    }
  },
  { header: 'Alloted Date', accessor: 'date' },
  { header: 'Patient Name ', accessor: 'patient_name' },
  { header: 'Gender', accessor: 'gender' },
  { header: 'Mobile No.', accessor: 'mobile_no' },
  { header: 'Scheme', accessor: 'scheme_name' },
  { header: 'Valid From', accessor: (row) => formatDate(row?.scheme_valid_from) },
  { header: 'Valid To', accessor: (row) => formatDate(row?.scheme_valid_to) },
  { header: 'Status', accessor: 'status', sx: { textTransform: 'uppercase' } }
];

const initialSchemeAllotmentDataObj = {
  data: [],
  loading: false
};

export const SchemeAllotment = () => {
  const [loading, setLoading] = useState(false);
  const [schemeAllotmentDataObj, setSchemeAllotmentDataObj] = useState(initialSchemeAllotmentDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [searchData, setSearchData] = useState([]);
  const [input, setInput] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [stateName, setStateName] = useState([]);
  const [cityName, setCityName] = useState([]);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        scheme_name: Yup.string().required(' '),
        patient_name: Yup.string().required(' '),
        mobile_no: Yup.string().required(' '),
        aadhar_no: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      date: getCurrentDateTime('date'),
      scheme_valid_to: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
      scheme_valid_from: new Date().toISOString().split('T')[0],
      country: 'IN'
    },
    mode: 'all'
  });
  const { handleSubmit, watch, setValue, reset } = methods;
  
  useEffect(() => {
    if (selectedRecord) {
      console.log('HELLO SELECTED RECORD', selectedRecord);
      const keyValuePair = getKeyPathValue(selectedRecord, '', ['_id', 'status', '__v']);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      const formattedScFromDate = selectedRecord?.scheme_valid_from
        ? new Date(selectedRecord.scheme_valid_from).toISOString().split('T')[0]
        : '';
      setValue('scheme_valid_from', formattedScFromDate);
      const formattedScToDate = selectedRecord?.scheme_valid_to
        ? new Date(selectedRecord.scheme_valid_to).toISOString().split('T')[0]
        : '';
      setValue('scheme_valid_to', formattedScToDate);
      setValue('image', selectedRecord?.image);
      setValue('scheme_name', selectedRecord?.scheme_name);
      if (selectedRecord.image) {
        const imageUrl = `${BASE_URL_FOR_FILE}/uploads/${selectedRecord.image}`;
        setImagePreview(imageUrl);
      }
    } else {
      reset();
      setImageFile(null);
      setImagePreview(null);
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    const editFlag = selectedRecord && currentAction === 'edit';
    const formData = new FormData();
    Object.entries(formValues).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });
    if (imageFile) {
      formData.append('image', imageFile);
    }
    try {
      const response = await request(editFlag ? '/scheme-update' : '/scheme-create', {
        method: editFlag ? 'PUT' : 'POST',
        params: editFlag ? selectedRecord._id : null,
        body: formData
      });
      if (response?.success) {
        toast(`Successfully ${editFlag ? 'edited' : 'created'} Scheme Allotment`, { variant: 'success' });
        setSelectedRecord(response?.data);
        setCurrentAction();
      } else {
        toast(`Failed to ${editFlag ? 'edit' : 'create'} Scheme Allotment`, { variant: 'error' });
      }
    } catch (error) {
      toast(`Error: ${error.message}`, { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };
  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/scheme-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel Scheme Allotment', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel Scheme Allotment', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/scheme-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Scheme Allotment', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Scheme Allotment', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setSchemeAllotmentDataObj({ loading: true });
    const response = await request('/scheme-list', { method: 'GET' });
    const sortedData = response.data.sort((a, b) => new Date(b.scheme_valid_from) - new Date(a.scheme_valid_from));
    const filteredData = sortedData.filter(
      (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
    );
    if (response.success) {
      setSchemeAllotmentDataObj({ loading: false, data: filteredData });
      setSearchData(filteredData);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setSchemeAllotmentDataObj({ loading: false });
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the file selected by the user

    if (file) {
      setImageFile(file); // Store the file in the state

      // Create a file reader to generate a preview
      const reader = new FileReader();
      reader.onload = () => {
        setImagePreview(reader.result); // This will display the image preview in the UI
      };
      reader.readAsDataURL(file); // Convert file to a data URL for preview
    }
  };

  useEffect(() => {
    if (schemeAllotmentDataObj.data && schemeAllotmentDataObj.data.length > 0) {
      setSearchData(schemeAllotmentDataObj.data);
      setIsFiltered(false);
    }
  }, [schemeAllotmentDataObj.data]);

  const handleSearch = () => {
    const lowercasedInput = input.toLowerCase();
    const filtered = schemeAllotmentDataObj.data.filter((item) =>
      item.card_no.toString().toLowerCase().includes(lowercasedInput)
    );
    setSearchData(filtered);
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
    handleSearch();
  };

  const getStateDropdown = useCallback(async () => {
    const data = await dropdownFetch('state');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('state', defaultState?._id);
    }
    setStateName(data);
  }, []);
  const getCityDropdown = useCallback(async () => {
    const data = await dropdownFetch('city');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('city', defaultState?._id);
    }
    setCityName(data);
    console.log('Hello City', cityName);
  }, []);

  useEffect(() => {
    getCityDropdown();
    getStateDropdown();
  }, [getCityByState, getStateDropdown]);
  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Scheme Card Allotment Form
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '60%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Card No/Date</Typography>
                  <TextField disabled sx={{ flex: 0.3 }} name="card_no" placeholder=" Enter Card No" />
                  <TextField disabled sx={{ flex: 0.4 }} name="date" />
                </Stack>

                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Scheme Name</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.7 }}
                    name="scheme_name"
                    menus={SCHEME_NAME}
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>

                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.7 }}
                    name="patient_name"
                    placeholder="Enter Patient Name"
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Age/Gender</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.2 }}
                    name="age"
                    placeholder="Age"
                  />
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.5 }}
                    name="gender"
                    menus={GENDER_DROPDOWN}
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Country</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.7 }}
                    menus={[{ _id: 'IN', name: 'India' }]}
                    name="country"
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>State</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.7 }}
                    name="state"
                    // menus={getStatesByCountry(watch('country'))}
                    menus={[
                      ...(getStatesByCountry(watch('address.country')) || []),
                      ...stateName.map((data) => ({ ...data, name: data.state }))
                    ]}
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>City</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.7 }}
                    name="city"
                    // menus={getCityByState(watch('country'), watch('state'))}
                    menus={[
                      ...(getCityByState(watch('address.country'), watch('address.state')) || []),
                      ...cityName.map((data) => ({ ...data, name: data.city }))
                    ]}
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Address</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.7 }}
                    name="address"
                    placeholder="Address"
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Mobile No.</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.7 }}
                    name="mobile_no"
                    placeholder="Enter Mobile No."
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Email ID</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.7 }}
                    name="email"
                    placeholder="Enter Email"
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Aadhar No.</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.7 }}
                    name="aadhar_no"
                    placeholder="Enter Aadhar No"
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Charge</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.7 }}
                    name="charge"
                    placeholder="Enter Charge"
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Valid From</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.7 }}
                    name="scheme_valid_from"
                    type="date"
                  />
                </Stack>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Valid To</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.7 }}
                    name="scheme_valid_to"
                    type="date"
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>Image</Typography>
                  <input
                    disabled={!['new', 'edit'].includes(currentAction)}
                    type="file"
                    onChange={handleFileChange}
                    sx={{ flex: 0.7 }}
                  />
                </Stack>
                {imagePreview && (
                  <Stack justifyContent="center" sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                    <img
                      src={imagePreview}
                      alt="Selected Preview"
                      style={{
                        width: '100px',
                        height: '100px',
                        borderRadius: '8px',
                        display: 'block',
                        padding: '20px'
                      }}
                    />
                  </Stack>
                )}
              </Stack>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Scheme Card Allotment Form
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem',
                // fontSize: '14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Enter Card No."
            placeholder="Enter Card No."
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_COLUMNS}
          data={searchData || []}
          loading={schemeAllotmentDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
